import { Deserializable } from '../../../lib/models/deserializable';

export class Consent implements Deserializable {
  public FaceToFaceInterview: string;
  public HomeInsurer: string;
  public ReadInsuranceDeclaration?: boolean;
  public ContactByTelephone?: boolean;
  public ContactByEmail?: boolean;
  public AuthorityToCompleteConfirmed?: boolean;
  public ContactBySms?: boolean;
  public ContactByPost?: boolean;
  public ConsentID: number;
  public MarketingOptionTickedMeansSendToSam?: boolean;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
